import { FC } from 'react';
import { TabPanel as MuiTabPanel, TabPanelProps as MuiTabPanelProps } from '@mui/lab';

interface TabPanelProps extends MuiTabPanelProps { }

const TabPanel: FC<TabPanelProps> = ({ ...props }) => (
  <MuiTabPanel sx={{ padding: 0 }}{...props} />
);

export default TabPanel;
